
import LayoutBlank from '../layout/blank.vue'
export default [{
  path: '/Assist',
  component: LayoutBlank,
  children: [
    {
      path: 'Login',
      name:'Login',
      component: () => import('@/views/Login/Login')
    },
    ]
}]



// WEBPACK FOOTER //
// ./src/router/Assist.js